import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useApi, useLoad, errMsg, fmtTime } from "@/lib/api";
import { PageHead, card, Sel, inputCls, Empty } from "@/components/admin/kit";

const STATUS = [["new", "New"], ["contacted", "Contacted"], ["demo_done", "Demo done"], ["pilot_agreed", "Pilot agreed"], ["not_interested", "Not interested"]];

function Row({ r, reload }) {
  const api = useApi();
  const [s, setS] = useState({ status: r.status, notes: r.notes || "" });
  const save = async () => { try { await api.put(`/demo-requests/${r.id}`, s); toast.success("Updated"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className={card} data-testid={`demo-request-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2"><b className="text-lg">{r.org_name}</b><span className="text-sm text-muted-foreground">{r.name} · {r.town}{r.state && `, ${r.state}`}</span><span className="ml-auto text-xs text-muted-foreground">{fmtTime(r.created_at)}</span></div>
      <p className="mt-1 text-sm">{r.phone} · {r.email || "no email"} · {r.preferred_language} · {r.patients_per_month || "patients/month not given"}</p>
      {r.message && <p className="mt-2 rounded-xl bg-[var(--lav)] p-3 text-sm">{r.message}</p>}
      <div className="mt-3 grid gap-2 sm:grid-cols-[200px_1fr_auto]">
        <Sel value={s.status} onChange={(v) => setS({ ...s, status: v })} options={STATUS} testid={`demo-status-${r.id}`} />
        <input className={inputCls} placeholder="Notes" value={s.notes} onChange={(e) => setS({ ...s, notes: e.target.value })} data-testid={`demo-notes-${r.id}`} />
        <Button onClick={save} data-testid={`demo-save-${r.id}`}>Save</Button>
      </div>
    </div>
  );
}

export default function DemoRequests() {
  const [list, reload] = useLoad("/demo-requests");
  return (
    <div data-testid="demo-requests-page">
      <PageHead title="Demo requests" sub="From the website form. You also get an email for each new request." />
      <div className="grid gap-3">{!list?.length ? <Empty>No requests yet.</Empty> : list.map((r) => <Row key={r.id} r={r} reload={reload} />)}</div>
    </div>
  );
}
